import './bootstrap';
import * as bootstrap from 'bootstrap';

// import '../css/dark-style.css';
import '../css/skin-modes.css';
// import '../css/color1.css';
// import '../css/style.css';


// import '../css/iconfonts/bootstrapicons/bootstrap-icons.css';
// import '../css/iconfonts/font-awesome/css/font-awesome.min.css';
// import '../css/iconfonts/glyphicons/glyphicon.css';
// import '../css/iconfonts/linearicons/Linearicons.css';
// import '../css/iconfonts/materialdesignicons/materialdesignicons.css';
// import '../css/iconfonts/pe-icon-7-stroke/Pe-icon-7.css';
// import '../css/iconfonts/simple-line-icons/simple-line-icons.css';
// import '../css/iconfonts/themify/themify.css';
// import '../css/iconfonts/typicons/typicons.css';
// import '../css/iconfonts/weathericons/weathericons.css';
// import '../css/iconfonts/feather/feather.css';
// import '../css/iconfonts/remixicon/remixicon.css';
import * as feather from 'feather-icons';

import '../landing/css/bootstrap.css';
import '../landing/css/style.css';

import '../landing/js/landing.js';
// import '../landing/js/shuffle.min.js';
import '../landing/js/plugins.init.js';
import '../landing/js/bootstrap.bundle.min.js';
import '../landing/js/accordion.min.js';

import './socket.io.min.js';


import Swal from 'sweetalert2';
window.Swal = Swal;

window.callErrorToast = function(a, b, c) {
    Swal.fire({
        toast: true,
        position: 'bottom-end',
        icon: 'error',
        title: a,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
};

window.callSuccessToast = function(a, b, c) {
    Swal.fire({
        toast: true,
        position: 'bottom-end',
        icon: 'success',
        title: a,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
};
